module.exports = __webpack_public_path__ + "img/features_moneymanager_mobile.4075d17d.png";